<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      title="Edit Data Potongan Asuransi"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Karyawan" label-cols-md="3">
          <multiselect
            :state="checkIfValid('dataKaryawanIdEdit')"
            v-model="$v.data.dataKaryawanIdEdit.$model"
            :disabled="false"
            :options="karyawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKaryawan"
            track-by="dataKaryawanId"
            @input="itikiwir(data.dataKaryawanIdEdit)"
            placeholder="-- Pilih Karyawan --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Asuransi" label-cols-md="3">
          <multiselect
            :state="checkIfValid('masterAsuransiIdEdit')"
            v-model="$v.data.masterAsuransiIdEdit.$model"
            :disabled="false"
            :options="asuransi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaAsuransi"
            track-by="id"
            @input="itikiwir2(data.masterAsuransiIdEdit)"
            placeholder="-- Pilih Asuransi --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Potongan" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('potonganAsuransi')"
            v-model="$v.data.potonganAsuransi.$model"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Nomor" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nomorAsuransi')"
            v-model="$v.data.nomorAsuransi.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          Batal
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "modalInput",
  props: ["data", "asuransi", "karyawan", "edit"],
  components: {
    Multiselect,
  },
  data() {
    return {
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dataKaryawanIdEdit: {
        required,
      },
      masterAsuransiIdEdit: {
        required,
      },
      potonganAsuransi: {
        required,
      },
      nomorAsuransi: {
        required,
      },
    },
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        // FOREACH diganti FOR
        // this.asuransi.forEach((ele) => {
        //   if (ele.id == this.data.masterAsuransiId) {
        //     this.data.masterAsuransiIdEdit = ele;
        //   }
        // });
        for (let i = 0; i < this.asuransi.length; i++) {
          if(this.asuransi[i].id == this.data.masterAsuransiId){
            this.data.masterAsuransiIdEdit = this.asuransi[i]
          }
        }
        // FOREACH diganti FOR
        // this.karyawan.forEach((ele) => {
        //   if (ele.id == this.data.dataKaryawanId) {
        //     this.data.dataKaryawanIdEdit = ele;
        //   }
        // });
        for (let i = 0; i < this.karyawan.length; i++) {
          if(this.karyawan[i].id == this.data.dataKaryawanId){
            this.data.dataKaryawanIdEdit = this.karyawan[i]
          }
        }
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    itikiwir(x) {
    },
    itikiwir2(x) {
    },
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.data.masterAsuransiId = vm.data.masterAsuransiIdEdit.id;
      vm.data.dataKaryawanId = vm.data.dataKaryawanIdEdit.dataKaryawanId;
      vm.data.poolPotonganAsuransiId = vm.data.poolPotonganId;
      vm.$axios
        .post("poolPotonganAsuransi/update", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH DATA ASURANSI",
              showing: true,
            });
            this.$bvModal.hide("modal-edit");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: _.toUpper(res.data.message),
              showing: true,
            });
            this.$bvModal.hide("modal-edit");
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          this.$bvModal.hide("modal-edit");
        });
    },
  },
};
</script>
